import { render, staticRenderFns } from "./selectCheck.vue?vue&type=template&id=36c874bb&"
import script from "./selectCheck.vue?vue&type=script&lang=ts&"
export * from "./selectCheck.vue?vue&type=script&lang=ts&"
import style0 from "./selectCheck.vue?vue&type=style&index=0&id=36c874bb&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports